// @ts-nocheck
import getQueryString from "@toolkit/Framework/Common/Utilities/getQueryString";
import { validate as isGUID } from "uuid";

const getGuidFromQueryString = (property: string) => {
    if (typeof window === "undefined") {
        return undefined;
    }

    const value = getQueryString(window.location.search)[property];

    if (!value || !isGUID(value)) {
        return undefined;
    }

    return value;
};

export default getGuidFromQueryString;
